<template>
  <!-- 服务条款 -->
  <div class="bg-round bg-fff">
    <div class="container">
      <div class="bg-fff" id="w-1200px">
        <Bread :list="breadList" class="ma-t-10" />
      </div>
      <div class="ma-t-40" v-if="detail && detail.Name">
        <div class="fon-30 t-center font-bold">
          {{ detail.Name }}
        </div>
      </div>
      <div>
        <img src="../img/index/index21.png" class="width100" alt="" srcset="" />
      </div>
      <div class="ma-t-40 lh-html" v-html="detail.Content" v-if="detail && detail.Content"></div>
    </div>
  </div>
</template>

<script>
import { getOther } from "../api.js";
export default {
  data() {
    return {
      breadList: [
        {
          name: "服务协议/使用条款",
          path: "",
        },
      ],
      detail:null
    };
    
  },
  created(){
    this.loadData()
  },
  methods:{
    loadData() {
      getOther({ code:'contract' }).then((res) => {
        this.detail = res.data.Data;
      });
    },
  }
};
</script>

<style lang="scss" scoped>
.container {
  min-height: 1150px;
  box-sizing: border-box;
  padding: 30px 0px;
}
</style>